import React from 'react';
import { Box } from '@chakra-ui/react';
import Footer from './Footer';

const Layout = ({ children }) => {
    return (
        <Box 
            minH="100vh" 
            position="relative" 
            overflow="hidden"
            bg="#0D1019"
            display="flex"
            flexDirection="column"
        >
            <Box flex="1">
                {children}
            </Box>
            <Footer />
        </Box>
    );
};

export default React.memo(Layout);
